import script from "./TagSelector.vue?vue&type=script&lang=ts&setup=true"
export * from "./TagSelector.vue?vue&type=script&lang=ts&setup=true"

import "./TagSelector.vue?vue&type=style&index=0&id=536fc456&scoped=true&lang=css"

import exportComponent from "/home/forge/tenant.mybcr.dev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-536fc456"]])

export default __exports__